<template>
  <div class="mb-container mb-detect-page">
    <resultPage
      v-if="!loading"
      :resultData="resultData"
      @restartDetect="getDeviceInfo"
    />
    <div class="mb-loading-box" v-if="loading">
      <div :class="{
        'mb-outer': true,
        'mb-loading': loading
      }">
        <div class="mb-inner">
          <span class="mb-text">{{ progressText }}</span>
        </div>
      </div>
      <p class="mb-tips">正在检测您的设备情况</p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { post } from '@/utils/ajax'
import resultPage from './resultPage'
import {
  FETCH_DEVICE_INFO,
  SEND_DEVICE_INFO,
  postMessageSyn,
  onPostMessageSynRegister,
  removeOnPostMessageSynRegister
} from '@/utils/dsbridge'

export default {
  components: {
    resultPage
  },
  computed: {
    ...mapState(['weishengRoute', 'testConfig']),
    testInfo() {
      return this.$store.state.testInfo
    },
    progressText() {
      return `${this.progress}%`
    }
  },
  data() {
    return {
      showResult: false,
      loading: false,
      progress: 30,
      timer: null,
      resultData: {}
    }
  },
  mounted () {
    this.onReceiveDeviceInfo()
    this.getDeviceInfo()
  },
  methods: {
    reload() {
      window.location.reload()
    },
    getDeviceInfo() {
      this.loading = true
      this.setProgress()
      postMessageSyn(FETCH_DEVICE_INFO)
    },
    onReceiveDeviceInfo() {
      /**
       * cpu 设备的cpu型号
       * cpuCoreCount Cpu核心数
       * memory 设备的存储空间大小，单位byte
       * os_version 设备的型号和os版本
       * device_net 设备的网络状态，为true表示正常，反之表示网络异常或不稳定
       * videoAuth 设备的拍照权限
       * micAuth  设备的录音权限
       */
      onPostMessageSynRegister(SEND_DEVICE_INFO, (res) => {
        this.progress = 100
        this.reportAllInfo(res)
        setTimeout(() => {
          this.loading = false
          this.stopProgress()
        }, 1000)
        const {
          cpu = '',
          memory = '',
          os_version = '',
          device_net = false,
          videoAuth = false,
          micAuth = false
        } = res
        const isAllPass = device_net && videoAuth && micAuth
        this.resultData = {
          ...res,
          cpu,
          memory,
          os_version,
          device_net,
          videoAuth,
          micAuth,
          device_net_text: `网络状态${device_net ? '正' : '异'}常`,
          isAllPass
        }
      })
    },
    // 上报设备数据
    async reportAllInfo(data) {
      const { device_net, videoAuth, micAuth, ...rest } = data
      // 设备状态；0：未通过，1：通过
      // 设备类型；1：网络与软硬件，2：摄像头，3：麦克风
      const getParams = ({ deviceInfo = '', deviceStatus = 0, deviceType, reason = '' }) => ({
        deviceInfo,
        deviceStatus,
        deviceType,
        reason
      })
      await this.reportInfo(getParams({ deviceInfo: JSON.stringify(rest), deviceStatus: Number(device_net), deviceType: 1 }))
      await this.reportInfo(getParams({ deviceInfo: '', deviceStatus: Number(videoAuth), deviceType: 2 }))
      await this.reportInfo(getParams({ deviceInfo: '', deviceStatus: Number(micAuth), deviceType: 3 }))
    },
    // 上报设备数据
    async reportInfo(params) {
      await post(`/home/devices/check/report`, {
        ...params,
        serialNumber: this.$store.state.browserFinger
      })
    },
    setProgress() {
      this.progress = 30
      this.timer = setInterval(() => {
        if (this.progress < 96) {
          this.progress = Math.floor((this.progress + Math.random() * 5) * 100) / 100
        } else {
          this.progress = 100
        }
      }, 100)
    },
    stopProgress() {
      clearInterval(this.timer)
      this.progress = 100
    }
  },
  destroyed() {
    removeOnPostMessageSynRegister(SEND_DEVICE_INFO)
  }
}
</script>
<style lang="scss" scoped>
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.mb-detect-page {
  min-height: 100%;

  .mb-loading-box {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 0;
    .mb-outer {
      width: 260px;
      height: 260px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background: url("~@/assets/images/detect/mb-outer-loading.png") no-repeat;
        background-size: contain;
      }
      &.mb-loading {
        &::after {
          animation: spin 1s linear infinite;
        }
      }
      .mb-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 224px;
        height: 224px;
        background: url("~@/assets/images/detect/mb-inner.png") no-repeat;
        background-size: contain;
        .mb-text {
          color: #fff;
          font-size: 39px;
        }
      }
    }
    .mb-tips {
      font-size: 32px;
      color: #333;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-top: 32px;
    }
  }
}
</style>
